import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Page, Lotissement, LotissementForm } from '../models';

@Injectable()
export class LotissementService {

  
  lotissementsUrl = environment.dns + 'api/lotissements/';

  constructor(private http: HttpClient) { }

  getPaginate(page: number, size: number, search: string = ""): Observable<Page<Lotissement>> {
      return this.http.get<Page<Lotissement>>(this.lotissementsUrl + 'paginate?page=' + page + '&size=' + size+"&search=" +search);
  }

  getList(): Observable<Lotissement[]> {
      return this.http.get<Lotissement[]>(this.lotissementsUrl + 'list');
  }

  getOne(id: number): Observable<Lotissement> {
      return this.http.get<Lotissement>(this.lotissementsUrl + id);
  }


  add(lotissementForm: LotissementForm): Observable<Lotissement> {
      return this.http.post<Lotissement>(this.lotissementsUrl, lotissementForm);
  }

  update(lotissementForm: LotissementForm): Observable<Lotissement> {
      return this.http.put<Lotissement>(this.lotissementsUrl, lotissementForm);
  }

  delete(id: number): Observable<boolean> {
      return this.http.delete<boolean>(this.lotissementsUrl + id);
  }
}
